export default function Schema(json) {
  if (!(this instanceof Schema)) {
    return new Schema(json);
  }
  this.json = json;

  Schema.prototype.getCreateFormState = function() {
    return Object.keys(this.json).reduce(
      (p, c) => {
        if (this.json[c].type === "array") {
          p.form[c] = [];
        } else if (this.json[c].type === "object") {
          p.form[c] = {};
        } else if (this.json[c].type === "boolean") {
          p.form[c] = false;
        } else {
          p.form[c] = "";
        }
        p.formValidation[c] = "";
        //HUE HUE
        return p;
      },
      { form: {}, formValidation: {} }
    );
  };

  Schema.prototype.toJSON = function() {
    return this.json;
  };

  Schema.prototype.validate = function(formValues) {
    const json = { ...this.json };
    if (!formValues) {
      return undefined;
    }
    return Object.keys(this.json).reduce(function(p, c) {
      return { ...p, [c]: validateField(c, formValues[c], json, formValues) };
    }, {});
  };

  Schema.prototype.getSearchFormStateFromSchema = function() {
    const json = { ...this.json };
    return Object.keys(json)
      .filter(it => json[it].search)
      .reduce((p, c) => {
        switch (json[c].type) {
          case "string":
            return {
              ...p,
              [c]: { value: "", modifier: "Contém", type: json[c].type }
            };
          default:
            return {
              ...p,
              [c]: { value: "", modifier: "Igual", type: json[c].type }
            };
        }
      }, {});
  };

  //
  const idValidator = (key, value, schema) => {
    if (value && typeof value !== "string") {
      return "Tipo inválido";
    }
    if (schema[key].required && !value) {
      return "Campo obrigatório";
    }
  };

  //
  const objectValidator = (key, value, schema) => {
    if (schema[key].required && !value) {
      return value instanceof Object;
    }
  };

  const primitivesValidator = (key, value, schema, formValues) => {
    if (value && schema[key].type === "number") {
      if (isNaN(Number(value))) {
        return "Número inválido";
      } else {
        return "";
      }
    }

    if (value && typeof value !== schema[key].type) {
      return "Tipo inválido";
    }
    if (schema[key].required && !value) {
      return "Campo obrigatório";
    }

    if (schema[key].validator) {
      return schema[key].validator(value, formValues);
    }

    return "";
  };

  const arrayValidator = (key, value, schema) => {
    if (schema[key].required && (!value || !(value.length && value.length > 0))) {
      return "Campo obrigatório";
    }
    if (value && !(value instanceof Array)) {
      return "Tipo inválido";
    }
  };

  const enumValidator = (key, value, schema) => {
    if (!schema[key].options) {
      throw new Error(`Options not defined for ${schema[key]} in schema`);
    }
    if (!value && schema[key].required) {
      return "Campo obrigatório";
    }
    window.b = value;
    window.a = schema[key].options;
    if (value && schema[key].options.indexOf(value) === -1) {
      return "Opção inválida";
    }
  };

  const typesValidatorMapper = {
    string: primitivesValidator,
    number: primitivesValidator,
    boolean: primitivesValidator,
    id: idValidator,
    array: arrayValidator,
    enum: enumValidator,
    object: objectValidator
  };

  const validateField = (key, value, schema, formValues) => {
    if (!schema[key].type) {
      throw new Error(`Type no defined for ${schema[key]} in schema`);
    }
    if (!typesValidatorMapper[schema[key].type]) {
      throw new Error(`Type validator not defined for ${schema[key].type} in schema`);
    }
    return typesValidatorMapper[schema[key].type](key, value, schema, formValues);
  };
}
